import React from 'react';
import { Button, Space, Typography } from 'antd';

const { Title } = Typography;

export default function EmptyState({
  hasFilters,
  onClear,
  onCreate,
}) {
  return (
    <div style={{
      textAlign: 'center',
      padding: '60px 20px',
      background: 'white',
      borderRadius: '8px',
      marginTop: '16px',
      border: '1px solid #e8e8e8'
    }}>
      <div style={{ fontSize: '64px', marginBottom: '16px', opacity: 0.5 }}>📋</div>
      <Title level={4} style={{ color: '#8c8c8c', marginBottom: '8px' }}>
        {hasFilters ? 'No tasks found' : 'No tasks yet'}
      </Title>
      <div style={{ color: '#bfbfbf', marginBottom: '24px', maxWidth: '400px', margin: '0 auto' }}>
        {hasFilters ? 'Try adjusting your search criteria or filters.' : 'Get started by creating your first task.'}
      </div>
      <Space>
        {hasFilters && (
          <Button onClick={onClear} size="middle" style={{ borderRadius: '6px', padding: '0 20px', height: '36px' }}>
            Clear Filters
          </Button>
        )}
        <Button
          type="primary"
          size="middle"
          onClick={onCreate}
          style={{ background: 'linear-gradient(45deg, #1890ff, #722ed1)', border: 'none', borderRadius: '6px', padding: '0 24px', height: '36px' }}
        >
          Create Task
        </Button>
      </Space>
    </div>
  );
}


